import {engineersEndpoint, usersEndpoint} from './routes';

export let getEngineers = async () => {
    const result = await fetch(engineersEndpoint, {
        mode: 'cors',
        credentials: 'omit',
        crossDomain: true
    });
    
    return await result.json();    
};

export let getUsers = async () => {
    const result = await fetch(usersEndpoint, {
        mode: 'cors',
        credentials: 'omit',
        crossDomain: true
    });
    
    return await result.json();    
};